import { GET_PRODUCTS, GET_ALL_PRODUCTS, ADD_PAKKET_PRODUCTS, GET_ALL_PAKKETTEN, GET_PAKKETTEN } from './actionTypes'
import firebase from "firebase";
import { firebaseStorage, firestoreDB } from '../../utils/firebase'
import { CLIENT_ID, OWNER_NAME } from '../../utils/config'
import { showMessageModal, showNotifaction, hideProductModal } from './miscActions'

export const addNewProduct = (data) => (dispatch) => {
  const { 
  productImage,
  productNaam,
  productCategorie,
  productPrijs } = data

  if(productNaam && productImage && productCategorie.length > 0 && productPrijs){
    const storageRef = firebaseStorage.ref()
    let productImageRef = storageRef.child(
      `${OWNER_NAME.split(" ").join("")}/${productNaam.toLowerCase().split(" ").join("")}-${Date.now()}`
    )
    productImageRef.put(productImage).then(function(snapshot){
      snapshot.ref.getDownloadURL().then(function(imageUrl){
        firestoreDB.collection('products').add({
          ...data,
          productNaam: data.productNaam.trim(),
          productOmschrijving: data.productOmschrijving.trim(),
          productId: data.productId.trim(),
          productImage: imageUrl,
          date_added: firebase.firestore.FieldValue.serverTimestamp(),
          imgPreview: null,
          salesPrice: 0
        })
      })
    }).then(function(){
      const feedback = {
        type: 'success',
        txt: 'Opslaan gelukt'
      }
      dispatch(
        showMessageModal(feedback)
      )
    })
  } else {
    const feedback = {
      type: 'warning',
      txt: 'Controleer of alle verplichte velden zijn ingevuld'
    }
    dispatch(showMessageModal(feedback))
  }

}

export const getProducts =() => (dispatch) => {
  firestoreDB.collection('products').where('productOwner', '==', CLIENT_ID).where('isVisible', '==', true).onSnapshot(function(querySnapshot){
    let products = []
    querySnapshot.forEach(function(doc){
      const product = doc.data();
      product.id = doc.id;
      product.itemPrice = parseFloat(doc.data().productPrijs)
      product.itemSalesPrice = parseFloat(doc.data().salesPrice)
      products.push(product)
    })
    dispatch({
      type: GET_PRODUCTS,
      payload: products
    })
  })
}


export const getAllProducts = () => (dispatch) => {
  firestoreDB.collection('products').where('productOwner', '==', CLIENT_ID).onSnapshot(function(querySnapshot){
    let products = []
    querySnapshot.forEach(function(doc){
      const product = doc.data();
      product.id = doc.id;
      product.key = doc.id;
      products.push(product)
    })
    dispatch({
      type: GET_ALL_PRODUCTS,
      payload: products
    })
  })
}


export const toggleProductVisibile=(id, bool, naam) => dispatch =>{
  firestoreDB.collection('products').doc(id).update({
    isVisible: bool
  }).then(function(){
    dispatch(showNotifaction('success', naam, 'Product zichtbaarheid aangepast' ))
  }).catch(function(error){
    const feedback = {
      type: 'warning',
      txt: error.message
    }
    dispatch(showMessageModal(feedback))
  })
}

export const updateProduct = (id, data) => dispatch => {
  const feedback = {
    type: 'loading',
    txt: 'Aan het opslaan'
  }
  dispatch(showMessageModal(feedback))
  const { productNaam, productImage } = data

  if(typeof(productImage) === 'object'){
    const storageRef = firebaseStorage.ref();
    let productImageRef = storageRef.child(
      `${OWNER_NAME.split(" ").join("")}/${productNaam.toLowerCase().split(" ").join("")}-${Date.now()}`
    )
    productImageRef.put(productImage).then(function(snapshot){
      snapshot.ref.getDownloadURL().then(function(imageUrl){
        firestoreDB.collection('products').doc(id).update({
          ...data,
          productNaam: data.productNaam.trim(),
          productOmschrijving: data.productOmschrijving.trim(),
          productId: data.productId.trim(),
          productImage: imageUrl
        })
      })
    }).then(function(){
      const feedback = {
        type: 'success',
        txt: 'Bijwerken gelukt'
      }
      dispatch(
        showMessageModal(feedback)
      )
    }).catch((error)=>{
      const feedback = {
        type: 'warning',
        txt: 'Opslaan mislukt. Probeer het later weer.'
      }
      dispatch(
        showMessageModal(feedback)
      )
    })
  } else {
    firestoreDB.collection('products').doc(id).update({
      ...data,
      productNaam: data.productNaam.trim(),
          productOmschrijving: data.productOmschrijving.trim(),
          productId: data.productId.trim(),
    }).then(function(){
      const feedback = {
        type: 'success',
        txt: 'Bijwerken gelukt'
      }
      dispatch(
        showMessageModal(feedback)
      )
    }).catch((error)=>{
      const feedback = {
        type: 'warning',
        txt: 'Opslaan mislukt. Probeer het later weer.'
      }
      dispatch(
        showMessageModal(feedback)
      )
    })
  }
}

export const deleteProduct = ( id ) => dispatch => {
  firestoreDB.collection('products').doc(id).delete().then(function(){
    const feedback = {
      type: 'success',
      txt: 'Product verwijdert'
    }
    dispatch(
      showMessageModal(feedback)
    )
  }).catch(function(error) {
    const feedback = {
      type: 'warning',
      txt: 'Verwijderen mislukt. Probeer het later weer.'
    }
    dispatch(
      showMessageModal(feedback)
    )
    dispatch(hideProductModal())
});
}


export const addPakketProducts = (data) => ({
  type: ADD_PAKKET_PRODUCTS,
  payload: data,
});

export const savePakketToDatabase = (data) => (dispatch) => {
  const {productImage, pakketNaam, producten, pakketPrijs, typePakket } = data;

  if (pakketNaam && producten.length > 0 && pakketPrijs && productImage && typePakket) {
    const storageRef = firebaseStorage.ref();
    let productImageRef = storageRef.child(
      `${OWNER_NAME.split(" ").join("")}/${pakketNaam
        .toLowerCase()
        .split(" ")
        .join("")}-${Date.now()}`
    )
    productImageRef.put(productImage).then(function(snapshot){
      snapshot.ref.getDownloadURL().then(function(imageUrl){
        firestoreDB
        .collection("pakketten")
        .add({
          ...data,
          pakketNaam: data.pakketNaam.trim(),
          productId: data.productId.trim(),
          productImage: imageUrl,
          date_added: firebase.firestore.FieldValue.serverTimestamp(),
        })
      })
    }).then(function () {
        const feedback = {
          type: "success",
          txt: "Opslaan gelukt",
        };
        dispatch(showMessageModal(feedback));
        dispatch(addPakketProducts([]))
      });
  } else {
    const feedback = {
      type: "warning",
      txt: "Controleer of alle verplichte velden zijn ingevuld",
    };
    dispatch(showMessageModal(feedback));
  }
};

export const getAllPakketten=()=>dispatch=>{
  firestoreDB.collection('pakketten').where('productOwner', '==', CLIENT_ID).onSnapshot(function(querySnapshot){
    let pakketten = [];
    querySnapshot.forEach(function(doc){
      const pakket = doc.data();
      pakket.id = doc.id;
      pakket.key = doc.id;
      pakketten.push(pakket)
    })
    dispatch({
      type: GET_ALL_PAKKETTEN,
      payload: pakketten
    })
  })
}


export const togglePakketVisibile = (id, bool, naam) => (dispatch) => {
  firestoreDB
    .collection("pakketten")
    .doc(id)
    .update({
      isVisible: bool,
    })
    .then(function () {
      dispatch(
        showNotifaction("success", naam, "Pakket zichtbaarheid aangepast")
      );
    })
    .catch(function (error) {
      const feedback = {
        type: "warning",
        txt: error.message,
      };
      dispatch(showMessageModal(feedback));
    });
};

export const deletePakket = (id) => (dispatch) => {
  firestoreDB
    .collection("pakketten")
    .doc(id)
    .delete()
    .then(function () {
      const feedback = {
        type: "success",
        txt: "Pakket verwijdert",
      };
      dispatch(showMessageModal(feedback));
    })
    .catch(function (error) {
      const feedback = {
        type: "warning",
        txt: "Verwijderen mislukt. Probeer het later weer.",
      };
      dispatch(showMessageModal(feedback));
      // dispatch(hideProductModal());
    });
};

export const getPakketten = () => (dispatch) => {
  
  firestoreDB
    .collection("pakketten")
    .where("productOwner", "==", CLIENT_ID)
    .where("isVisible", "==", true)
    .onSnapshot(function (querySnapshot) {
      let pakketten = [];
      querySnapshot.forEach(function (doc) {
        const product = doc.data();
        product.id = doc.id;
        product.itemPrice = doc.data().pakketPrijs;
        product.pakketPrijs = doc.data().pakketPrijs;
      product.typePakket = doc.data().typePakket === undefined ? 'null' : doc.data().typePakket
      product.volgNum = doc.data().volgNum === undefined ? 100 : doc.data().volgNum
        product.productCategorie = 'pakket'
        pakketten.push(product);
      });
      dispatch({
        type: GET_PAKKETTEN,
        payload: pakketten,
      });
    });
};

export const updatePakket = (id, data) => (dispatch) => {
  const feedback = {
    type: "loading",
    txt: "Aan het opslaan",
  };
  dispatch(showMessageModal(feedback));
  const { pakketNaam, productImage } = data;

  if (typeof productImage === "object") {
    const storageRef = firebaseStorage.ref();
    let productImageRef = storageRef.child(
      `${OWNER_NAME.split(" ").join("")}/${pakketNaam
        .toLowerCase()
        .split(" ")
        .join("")}-${Date.now()}`
    );
    productImageRef
      .put(productImage)
      .then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (imageUrl) {
          firestoreDB
            .collection("pakketten")
            .doc(id)
            .update({
              ...data,
              pakketNaam: data.pakketNaam.trim(),
              productImage: imageUrl,
            });
        });
      })
      .then(function () {
        const feedback = {
          type: "success",
          txt: "Bijwerken gelukt",
        };
        dispatch(showMessageModal(feedback));
      })
      .catch((error) => {
        const feedback = {
          type: "warning",
          txt: "Opslaan mislukt. Probeer het later weer.",
        };
        dispatch(showMessageModal(feedback));
      });
  } else {
    firestoreDB
      .collection("pakketten")
      .doc(id)
      .update({
        ...data,
        pakketNaam: data.pakketNaam.trim(),
      })
      .then(function () {
        const feedback = {
          type: "success",
          txt: "Bijwerken gelukt",
        };
        dispatch(showMessageModal(feedback));
      })
      .catch((error) => {
        const feedback = {
          type: "warning",
          txt: "Opslaan mislukt. Probeer het later weer.",
        };
        dispatch(showMessageModal(feedback));
      });
  }
};